<template>
    <modal name="recovery" v-bind:class="{ 'dd-m-modal--auth--recovery-success' : step == 2 }"
        class="dd-m-modal dd-m-modal--auth dd-m-modal--auth--recovery">
        <button v-on:click="hide()" type="button" class="dd-m-auth__close-btn">
            <i class="dd-m-icon icon-close"></i>
        </button>

        <auth-recovery v-if="step === 1"></auth-recovery>

        <auth-success v-if="step === 2" :email="email"></auth-success>

        <auth-reset-password v-if="step === 3" :token="token"></auth-reset-password>
    </modal>
</template>
<script>
    import AuthRecovery from "./auth-recovery";
    import AuthSuccess from "./auth-success";
    import AuthResetPassword from "./auth-reset-password";
    const queryString = require('query-string');

    export default {
        name: 'modal-recovery',
        components: {AuthResetPassword, AuthSuccess, AuthRecovery},
        props: ['name'],
        data: () => {
            return {
                step: 1,
                email: null,
                token: null
            }
        },
        mounted() {
            PubSub.subscribe('openRecoveryModal', (msg, param) => {
                this.step = param ? 1 : 2;
                this.show();
            });
            PubSub.subscribe('closeRecoveryModal', () => this.hide());
            PubSub.subscribe('updateRecoveryStep', (msg, data) => this.goTo(data.step, data.email));
            this.checkToken();
        },
        methods: {
            show() {
                this.$modal.show('recovery');
            },
            hide() {
                this.$modal.hide('recovery');
            },
            goTo(step, email) {
                if (email) this.email = email;
                this.step = step;
            },

            /**
             * @description
             * Verifica se existe o parâmetro token na URL. Caso exista abrimos a modal para reset de senha.
             */

            checkToken() {
                const parsed = queryString.parse(location.search);
                if (parsed.t) {
                    this.step = 3;
                    this.token = parsed.t;

                    setTimeout(() => {
                        this.show();
                    }, 100);
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/auth/modal-recovery.vue